import { gql } from '@apollo/client';
export const HIGHLIGHT_IN_DOCUMENT_MUTATION = gql `
  mutation HighlightInDocument($query: String!, $texts: [String!]!) {
    highlightInDocument(query: $query, texts: $texts) {
      similarities {
        index
        score
      }
    }
  }
`;
